module.exports = __webpack_public_path__ + "img/mic_small_grey.248d189d.svg";